import { Pipe, PipeTransform } from '@angular/core';
import { ShoppingCartItem, UserOrderItem } from '../../models/shopping';
import { extractShoppingCartItemImage } from '../../utils/cart';

@Pipe({
  name: 'shoppingCartItemImage',
})
export class ShoppingCartItemImagePipe implements PipeTransform {
  transform(
    value: ShoppingCartItem | UserOrderItem,
    ...args: unknown[]
  ): string {
    return extractShoppingCartItemImage(value);
  }
}
